import React, { forwardRef } from 'react';

const MapUI = forwardRef((props: any, ref: any) => {
  return <div className="robot-map-container" ref={ref}></div>;
});

export default React.memo(MapUI);
